import { NgModule, CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { DataTablesModule } from 'angular-datatables';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MemberMisReportComponent } from './member-mis-report/member-mis-report.component';
import { ProEnablementFormSubmissionComponent } from './pro-enablement-form-submission/pro-enablement-form-submission.component';
import { ReadonlyProEnablementFormComponent } from './readonly-pro-enablement-form/readonly-pro-enablement-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { OtpModule } from '../otp.module';


@NgModule({
  declarations: [MemberMisReportComponent, ProEnablementFormSubmissionComponent, ReadonlyProEnablementFormComponent] ,
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    DataTablesModule,
    BsDatepickerModule,
    OtpModule
  ],
  
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]

})
export class ProEnablementModule { }
